import axios from "axios";
import {TRIGGER_IMPORT_ENDPOINT} from "@/constants/endpoints";
import authHeader from "@/services/auth-header";

class  TriggerService {

    public importPostalRegister(board: string) {
        return axios.post<void>(`${TRIGGER_IMPORT_ENDPOINT}/postal-register/${board}`, {}, {headers: authHeader()})
    }

}

export default new TriggerService()